export const getPluginList = (variant: "minimal" | "full" = "minimal") => {
  return variant === "minimal"
    ? "lists link"
    : "fullscreen lists table link image code preview hr";
};
export const getToolbarButtons = (variant: "minimal" | "full" = "minimal") => {
  return variant === "minimal"
    ? "bold italic | bullist numlist | link"
    : "undo redo | table tabledelete | styleselect fontsizeselect | " +
        "bold italic hr | alignleft aligncenter alignright alignjustify | forecolor backcolor " +
        " | numlist bullist outdent indent | image link | removeformat preview fullscreen";
};
export const EditorSkinUrl = "/vendor/tinymce/skins/ui/oxide";
export const EditorContentCss =
  "/vendor/tinymce/skins/content/default/content.min.css";

export const RTFDefaultStyles = `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style-type: none;
  font-family: "PT Sans", sans-serif;
  font-weight: 400;
}
body {line-height: 1.1rem;  -webkit-font-smoothing: antialiased;  -moz-osx-font-smoothing: grayscale;  font-size: clamp(1rem, 1.5vw, 1.125rem);}
h1 { font-size: 2.4375rem; font-weight: 700; }
h2 { font-size: 1.9375rem; font-weight: 600; }
h3 { font-size: $font-size-big; }
h4 { font-size: $font-size-medium; }
h5,
h6 { font-size: $font-size-small; }
h3,
h4,
h5,
h6,
.h3 { font-weight: 500; }
h1,
h2,
h3,
h4,
h5 { margin: 18px 0; }
p { margin: 10px; text-align: justify; text-justify: inter-word; line-height: 20pt; }
strong { font-size: 1rem !important;  font-weight: 600 !important; }
.alignr { text-align: right; }
.alignc { text-align: center; }
.alignl { text-align: left; }
ul li { list-style-type: circle; margin-left: 30px !important; }
table { width: 100%; border-collapse: collapse; }
td, th { padding: 10px; text-align: left; white-space: nowrap; }
th { font-weight: 700; }
`;
